import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import moment from 'moment'

interface Column {
  id: string
  subId?: string
  label: string
  minWidth?: number
  align?: 'right'
  format?: (value: number) => string
}

const columns: Column[] = [
  { id: 'id', label: 'Id', minWidth: 170 },
  { id: 'name', label: 'Name', minWidth: 100 },
  // { id: 'video', subId: 'videoType', label: 'Type', minWidth: 100 },  
  // { id: 'video', subId: 'videoURL', label: 'URL', minWidth: 100 },  
  // { id: 'uploadId', label: 'Upload Id', minWidth: 100 }, 
  { id: 'uploadStatus', label: 'Upload Status', minWidth: 100 },
  // { id: 'createdOn', label: 'Uploaded Date', minWidth: 100 },
  // { id: 'jobConvertId', label: 'Job Convert Id', minWidth: 100 },
  { id: 'jobConvertStatus', label: 'Job Convert Status', minWidth: 100 },
  // { id: 'modifiedOn', label: 'Job Done Date', minWidth: 100 },
  { id: 'isAvailable', label: 'Available?', minWidth: 100 },
  // { id: 'videoId', label: 'Video Id', minWidth: 100 },
  // { id: 'videoType', label: 'Video Type', minWidth: 100 },
]

interface Data {
  id: string;
  uploadId: string;
  uploadStatus: string;
  jobConvertStatus: string;
  jobConvertId: string;
  createdOn: Date;
  createdBy: number;
  modifiedOn: Date | undefined;
  modifiedBy: number | undefined;
  videoId: number;
  videoType: string;
  video: {
    id: number;
    name: string;
    modifiedBy: number;
    isAvailable: boolean;
    modifiedOn: Date | undefined;
    sequence: number;
    createdBy: number;
    createdOn: Date | undefined;
    description: string;
    videoDuration: number;
    videoType: number;
    videoURL: string;
  }
}

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
})

interface IStickHeaderTableProps {
  videoProgresses: any[]
}

const StickyHeadTable: React.FC<IStickHeaderTableProps> = ({ videoProgresses }) => {
  const classes = useStyles()
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  const formatField = (column: Column, value: any) => {
    let result = value
    switch (column.id) {
      case 'id':
        result = column.id
        break;
      case 'name':
        result = value.videoMaterial.name
        break
      case 'uploadStatus':
        result = value.uploadStatus
        break
      case 'jobConvertStatus':
        result = value.jobConvertStatus
        break;
      case 'isAvailable':
        result = value.videoMaterial.isAvailable ? 'Yes' : 'No'
        break
      
    }

    return result
  }

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column, idx) => (
                <TableCell
                  key={`column_${idx + 1}`}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {
              videoProgresses.map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                    {columns.map((column, idx) => {
                      return (
                        <TableCell key={`column_${idx + 1}`} align={column.align}>
                          {formatField(column, row)}
                        </TableCell>
                      )
                    })}
                  </TableRow>
                )
              })
            }
          </TableBody>
        </Table>
      </TableContainer>
      {/* <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={videoProgresses.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      /> */}
    </Paper>
  )
}

export default StickyHeadTable